module.exports = __webpack_public_path__ + "static/media/27.d232b98f.jpg";